import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["className"];
import * as React from 'react';
import clsx from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";
var Linkedin = _ref => {
  var {
      className
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    fill: "none",
    viewBox: "0 0 24 24",
    "data-testid": "linkedin",
    className: clsx('stroke-current', className)
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M4.2663 20h3.3179V9.307H4.2663V20ZM4 5.925c0 1.0632.86 1.9252 1.9252 1.9252 1.0609 0 1.921-.8663 1.921-1.9251C7.8461 4.8619 6.986 4 5.9251 4 4.86 4 4 4.862 4 5.925ZM16.6865 20H20v-5.8671c0-2.8789-.6199-5.0927-3.9771-5.0927-1.6109 0-2.6936.8882-3.1345 1.7282h-.0437V9.3071H9.6666V20h3.3091v-5.2852c0-1.3957.262-2.7476 1.9864-2.7476 1.7026 0 1.7244 1.5969 1.7244 2.8351V20Z"
    })
  }));
};
export default Linkedin;